<template>
  <div>
    <!--    <div>DEBUG stempelkarteLoaded={{ !!stempelkarteLoaded }}</div>-->
    <!--    <div>DEBUG loggedIn={{ !!$store.getters.loggedIn }}</div>-->

    <div class="stempelRahmen" v-if="$store.getters.loggedIn && stempelkarteLoaded">
      <div class="text-center mb-7">
        <div v-if="$store.getters.loggedIn">Deine aktuelle Stempelkarte</div>
        <StempelAnzahl></StempelAnzahl>
      </div>
      <v-row class="">
        <v-col cols="3" v-for="stempel in 10" class="pa-1">
          <div class="superCenter" v-if="stempel <= stempelCounter">
            <img class="stempelImage" src="../assets/loyalty/stempel.png">
          </div>
          <div class="superCenter" v-else>
            <div class="circle"></div>
          </div>
        </v-col>
      </v-row>
    </div>

    <div v-if="$store.getters.loggedIn && !stempelkarteLoaded">
      <v-layout row wrap>
        <v-flex xs12 v-for="n in 1">
          <v-skeleton-loader
              class="mx-auto"
              max-width="600"
              type="image, article"
          ></v-skeleton-loader>
        </v-flex>
      </v-layout>
    </div>

  </div>
</template>


<script>

import store from "../store/store";
import StempelAnzahl from "./StempelAnzahl.vue";
import {ebus} from "../vendor/ebus";
import {clearEvents} from "../vendor/util";

export default {
  components: {StempelAnzahl},

  data: () => ({
    stempelkarteLoaded: false,
  }),

  created() {
    ebus.$on('loggedInWasUpdatedTo', (loggedIn) => {
      this.init();
      if (!loggedIn) {
        this.stempelkarteLoaded = true; // promotion stempelkarte
      }
    });
    ebus.$on('stempelkarteBigWasUpdated', () => {
      this.stempelkarteLoaded = true;
    });
  },

  mounted() {
    this.init();
    setTimeout(() => {
      this.stempelkarteLoaded = true; //promotion stempelkarte
    }, 2000);
  },

  destroyed() {
    clearEvents([
      'loggedInWasUpdatedTo',
      'stempelkarteBigWasUpdated',
    ]);
  },

  computed: {
    punktestand() {
      return store.getters.stempelkarte.punktestand;
    },
    stempelCounter() {
      let p = this.punktestand;
      let r = 0;
      if (p > 0) {
        r = 1;
      }
      let t = Math.trunc(p / 10);
      if (t > 1) {
        r = t;
      }
      if (r > 10) {
        r = 10;
      }
      return r;
    },
  },

  methods: {
    init() {
      ebus.$on('stempelkarteBigWasUpdated', () => {
        this.stempelkarteLoaded = true;
      });
      if (store.getters.loggedIn) {
        ebus.$emit('loadStempelkarte', {retryOnError: true});
      }
    },
  },

}

</script>


<style scoped lang="scss">
@import '../styles/base';
@import '../styles/stempel';

$colorStrongGelb: yellow;

$colorCirle: $stempelTextColor;

.fixWinner {
  position: fixed;
  z-index: 150;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $color-secondary;
}

.winnerText {
  color: $color-primary !important;
}

.scontainer {
  padding: 5px;
}

.stempelImage {
  width: 100%;
  max-width: 150px;
}

.circle {
  border: 2px dashed $colorCirle;
  -moz-border-radius: 75px;
  -webkit-border-radius: 75px;
  width: 80%;
  aspect-ratio: 1;
  max-width: 150px;
}
</style>
